/**
 * The build this bundle came from, inlined by `env.NEXT_PUBLIC_BUILD_SHA` in
 * `next.config.ts`. Empty outside Vercel, which disables the version check in local dev.
 *
 * Read it from here and nowhere else — `/api/version` and `VersionWatcher` compare
 * against each other, so a runtime lookup of `VERCEL_GIT_COMMIT_SHA` on one side would
 * be a false positive waiting for the day the two diverge.
 */
export const BUILD_SHA = process.env.NEXT_PUBLIC_BUILD_SHA || '';
